import React, { useState, useRef } from "react";
import styled from "styled-components";
import { data } from "../../components/blog/data"; 


const BlogSectionContainer = styled.div`
    text-align: center;
    margin-top: 5%;
`;

const BlogHeader = styled.h2`
    color: #9D2222;
    font-family: Roboto;
    font-size: 40px;
    font-weight: 500;
    padding-bottom: 5%;

    @media screen and (max-width: 768px) {
        font-size: 20px;
        padding-bottom: 10%;
    }
`;

const BlogWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    align-items: center;
    grid-gap: 5%;

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        margin: 0 0;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
    }
`;

const BlogLink = styled.a`
    text-decoration: none;
    color: inherit;
    width: 100%;
    padding-bottom: 10%;

    @media screen and (max-width: 768px){
        padding-bottom: 10%;
    }
`;

const BlogPostContainer = styled.div`
    display: flex;
    align-content: center;
	flex-direction: column;
	/* height: 500px; */
	width: 60%;
    margin: auto;

    @media screen and (max-width: 768px){
        width: 80%;
    }


`;

const BlogImage = styled.img`
    width: 100%;
    border-radius: 10px;
`;

const BlogTitle = styled.h3`
    margin-top: 5%;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 1em;
    line-height: 25px;
    color: #000000;
    text-align: left;
 	overflow:none;
`;

const BlogSeperator = styled.div`
    border-top: solid #000;
    width: 100%;
    padding-bottom: 5%;

`;

const BlogSubtitle = styled.p`
    margin-top: 5px;
    font-family: 'Roboto';
    font-weight: 500;
    font-size: .9em;
    line-height: 25px;
    color: #727272;
    text-align: left;
`;

const BlogSubtext = styled.p`
    text-align: left;
    font-family: Roboto;
    font-style: normal;
    font-weight: 300;
    font-size: 1em;
    line-height: 25px;
    margin-top: 0px;
    color: #585858;
`;

const PaginationContainer = styled.div`
    margin-top: 5%;    
`;

const PaginationButton = styled.span`
    margin: 0 5px;
    padding: 8px 12px;
    cursor: pointer;
    background-color: ${(props) => (props.active ? '#B55959' : 'white')};
    color: ${(props) => (props.active ? 'white' : '#B55959')};
`;

export function BlogHomePage (){
    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 4;
    const blogSectionRef = useRef(null);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);

        if (pageNumber >= 1 && pageNumber <= 3 && blogSectionRef.current) {
            // Get the top position of the BlogSectionContainer
            const topPosition = blogSectionRef.current.offsetTop;

            // Scroll to the top of the BlogSectionContainer div
            window.scrollTo({
                top: topPosition - 100,
                behavior: 'smooth' // Optional: Smooth scrolling animation
            });
        }
    }

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = data.slice(indexOfFirstPost, indexOfLastPost);

    
    return(
        <BlogSectionContainer ref={blogSectionRef}>
            <BlogHeader>The Expedient Recruiting Blog</BlogHeader>
            <BlogWrapper>
                {currentPosts.map((post) => (
                    <BlogLink key={post.id} href={`${post.link}`}>
                        <BlogPostContainer>
                            <BlogImage src={post.img} alt={post.title}/>
                            <BlogTitle>{post.title}</BlogTitle>
                            {post.subtitle && <BlogSubtitle>{post.subtitle}</BlogSubtitle>}
                            <BlogSeperator />
                            <BlogSubtext>{post.subtext}</BlogSubtext>
                        </BlogPostContainer>
                    </BlogLink>
                ))}
            </BlogWrapper>
            <PaginationContainer>
            {Array.from({ length: Math.ceil(data.length / postsPerPage) }, (_, index) => (
                <PaginationButton
                    key={index + 1}
                    active={currentPage === index + 1}
                    onClick={() => paginate(index + 1)}
                >
                {index + 1}
                </PaginationButton>
            ))}
            </PaginationContainer>
        </BlogSectionContainer>
    )
}